export default __webpack_public_path__ + "static/media/ssl_encryption.54ddf05f.png";